import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

/**
 * Report Status Controller
 * Polls the report status endpoint and reloads the turbo frame when complete.
 */
export default class extends Controller {
  static values = {
    reportId: String,
    pollInterval: { type: Number, default: 2000 },
  }

  static targets = ["status"]

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.timer = setInterval(() => this.checkStatus(), this.pollIntervalValue)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  async checkStatus() {
    try {
      // Build the status URL from current page URL
      const currentUrl = window.location.pathname
      const statusUrl = `${currentUrl}/status`

      const response = await get(statusUrl, {
        credentials: "include",
        responseKind: "json",
      })

      if (!response.ok) return

      const data = await response.json

      if (this.hasStatusTarget) {
        this.statusTarget.textContent = `Status: ${data.status.charAt(0).toUpperCase() + data.status.slice(1)}`
      }

      if (data.status === "completed" || data.status === "failed") {
        this.stopPolling()
        // Reload the turbo frame to show the final state
        window.location.reload()
      }
    } catch {
      // Silently handle network errors - will retry on next poll
    }
  }
}
